import { render } from "./videoPlayer.vue?vue&type=template&id=2fa2d434&scoped=true"
import script from "./videoPlayer.vue?vue&type=script&lang=js"
export * from "./videoPlayer.vue?vue&type=script&lang=js"

import "./videoPlayer.vue?vue&type=style&index=0&id=2fa2d434&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/FK-YF23001-01-生产-01-综合管理后台sznc_admin-前端构建部署/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa2d434"]])

export default __exports__